import Styled from 'styled-components'

export default Styled.div`
* {
    /* background-color: #272B4A; */
    color: rgba(255, 255, 255, 0.7);
    border: none!important;
}

/* MuiPaper-root MuiPaper-elevation2 MuiPaper-rounded */
    .MuiToolbar-gutters {
        background-color: #272B4A;
    }
    thead {
        background: #1B203A!important;
        th {
        background: #1B203A!important;
        color: rgba(255, 255, 255, 0.8);
        }
    }

    .MuiPaper-elevation2 {
        background-color: #272B4A;
    }

    div.MuiToolbar-root {
        input {
            color: rgba(255, 255, 255, 0.8)!important;
        }
    }
    tr.MuiTableRow-root td {
        padding-top: 1em;
        padding-bottom: 1em;
    }
    table.MuiTable-root {
        font-size: 0.9rem;
        background: #272B4A;
      }
      .MuiPaper-elevation2 {
        box-shadow: none;
        border-radius: 5px;
        overflow: hidden;
        border: 1px solid #E6E8F1;
    }
    div.Component-horizontalScrollContainer-12 {
    background-color: #272B4A;
    }
    td.MuiTableCell-body {
        color: rgba(255, 255, 255, 0.8);
    }
    footer {
        display: flex;
        padding-top:3px;
        padding-bottom: 1em;
        padding-right:5px;
        align-items: center;
        justify-content: flex-end;
        background:#272b4a;
    }
   
`
